var React = require('react');

function IconTravel (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeLinejoin":"round","transform":"translate(57 8)"},[React.createElement("path",{"d":"m0 16.8h79.7l-40 59.1z","key":0}),React.createElement("path",{"d":"m39.8 75.9v35.1","key":1}),React.createElement("path",{"d":"m25.9 110.7h27.9","key":2}),React.createElement("path",{"d":"m.2.5 24.4 6.6 10.1 30.2","key":3}),React.createElement("path",{"d":"m14.4 37.3h51.4","key":4}),React.createElement("path",{"d":"m69.1 17.1c0-.4-.1-.9-.1-1.3 0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9c-3.1 0-6-1.1-8.2-3","key":5})]));
}

IconTravel.defaultProps = {"viewBox":"0 0 208 128"};

module.exports = IconTravel;

IconTravel.default = IconTravel;
